(function() {
  const overlay = document.getElementById('op-search-overlay');
  const input = document.getElementById('op-search-input');
  const closeBtn = document.getElementById('op-search-close');
  const openBtns = document.querySelectorAll('[data-action="open-search"]');

  if (!overlay || !input) return;

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open');
    setTimeout(() => { input.focus(); input.click(); }, 100);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open');
    input.value = '';
  }

  // Open on button click
  openBtns.forEach(btn => btn.addEventListener('click', openSearch));

  // Close on X button
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  // Close when clicking outside the inner container
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeSearch();
  });
})();
